import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function CircleProgress({ percentage, size = 50, strokeWidth = 10 }) {
    const { t } = useTranslation();
    const [animatedPercent, setAnimatedPercent] = useState(0);
    const [shouldAnimate, setShouldAnimate] = useState(false);

    useEffect(() => {
        setShouldAnimate(false);
        setAnimatedPercent(0);

        const timeout = setTimeout(() => {
            setShouldAnimate(true);
            setAnimatedPercent(percentage);
        }, 50);

        return () => clearTimeout(timeout);
    }, [percentage]);

    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (animatedPercent / 100) * circumference;

    return (
        <div className="flex flex-col justify-center items-center">
            <svg width={size} height={size + 10}>
                <defs>
                    <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
                        <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor="#000" floodOpacity="0.2" />
                    </filter>
                </defs>
                <g filter="url(#dropShadow)">
                    <circle
                        stroke="#374151"
                        fill="transparent"
                        strokeWidth={strokeWidth}
                        r={radius}
                        cx={size / 2}
                        cy={size / 2}
                    />
                    <circle
                        // Applichiamo la classe di transizione solo quando shouldAnimate===true
                        className={shouldAnimate ? 'transition-all duration-1000 ease-out' : ''}
                        stroke="#FBBF24"
                        fill="transparent"
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        r={radius}
                        cx={size / 2}
                        cy={size / 2}
                        transform={`rotate(-90 ${size / 2} ${size / 2})`}
                    />
                </g>
                <text
                    x="50%"
                    y="50%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    className="text-2xl font-semibold fill-current text-gray-800"
                >
                    {Math.round(animatedPercent)}%
                </text>
            </svg>
            <div className="text-center mt-2 text-lg font-medium text-gray-800">
                {t('securityTabs.complianceLevel')}
            </div>
        </div>
    );
}
